/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

exports.onClientEntry = () => {
  // polyfills
  if (!String.prototype.startsWith) {
    require('core-js/fn/string/starts-with')
  }
  if (!Array.prototype.find) {
    require('core-js/fn/array/find')
  }
  if (!Array.prototype.fill) {
    require('core-js/fn/array/fill')
  }
}



// WEBPACK FOOTER //
// ./gatsby-browser.js